import { ReactNode } from "react";
import { z } from "zod";

import { REFERRAL_CODE_PATTERN } from "@/lib/referral";

export const PurchaseLicenseFormSchema = z.object({
  referralCode: z.string({ error: "Referral Code cannot be empty." }),
  quantity: z
    .string({
      error: "Quantity cannot be empty.",
    })
    .regex(/\d/i),
  price: z.string().readonly().optional(),
  hasReferralCode: z.boolean().default(false).optional(),
  isTermsCheckboxAccepted: z.boolean({
    error: "You must check the T&C.",
  }),
  isPrivacyPolicyAccepted: z.boolean({
    error: "You must check the privacy policy.",
  }),
});

/**
 * Terminal-login referral code. Mirrors `isValidReferralCode` so a code
 * `storeReferralCode` would reject shows an inline error instead of the submit
 * silently doing nothing.
 */
export const ReferralCodeFormSchema = z.object({
  referralCode: z
    .string({ error: "Referral Code cannot be empty." })
    // Pasted codes often carry a stray space; trim before the pattern check.
    .trim()
    .min(1, { error: "Referral Code cannot be empty." })
    .regex(REFERRAL_CODE_PATTERN, {
      error: "Use 1-32 letters, digits, '-' or '_'.",
    }),
});

export type DashboardProps = {
  children?: ReactNode;
  className?: string;
  code?: string;
};
